import { IMAGE_BAMBOO_HR_BADGE, IMAGE_DEEL_BADGE } from '~/rails_assets';

// Keep in sync with Integration::HRIS_PROVIDER_NAMES (app/models/integration.rb).
export const HRIS_PROVIDER_NAMES = {
  bamboo_hr: 'BambooHR',
  deel_hris: 'Deel',
};

const HRIS_IMPORTED_BADGE_IMAGES = {
  bamboo_hr: IMAGE_BAMBOO_HR_BADGE,
  deel_hris: IMAGE_DEEL_BADGE,
};

export function hrisProviderName(integrationType) {
  return HRIS_PROVIDER_NAMES[integrationType] || integrationType;
}

export function hrisImportedBadgeImage(integrationType) {
  return HRIS_IMPORTED_BADGE_IMAGES[integrationType] || IMAGE_BAMBOO_HR_BADGE;
}

export function hrisImportedBadgeTooltip(integrationType) {
  return `Synced from ${hrisProviderName(integrationType)}`;
}

export function hrisManagedTooltip(integrationType) {
  return `Managed in ${hrisProviderName(integrationType)}`;
}
